import React, { useEffect, useState, useRef } from "react"
import "./UserList.scss"
import AuthenticationApi from "Api/AuthenticationApi"
import * as Yup from "yup"

import { useNavigate } from "react-router-dom"
import {
  Button,
  Col,
  Modal,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { set } from "lodash"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { Toast } from "primereact/toast"

const UserList = () => {
  document.title = "Users-List"
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const userData = JSON.parse(localStorage.getItem("userData"))
  // const { userData } = useContext(UserContext)
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)

  const [modal, setModal] = useState(false)
  const toast = useRef(null);

  const toggle = () => setModal(!modal)

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Users", link: "#" },
    { label: "User List", link: "#" },
  ]
  const [usersData, setuserData] = useState([])
  const [loading, setLoading] = useState(true)
  const [addUserLoader, setAddUserLoader] = useState(false)

  const getAllAnalystDetails = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    AuthenticationApi.getAnalyst(config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setuserData(response.data.users)
          setTotalRecords(response.data.totalRecords)
        }
      })
      .catch(error => {
      })
  }

  useEffect(() => {
    getAllAnalystDetails()
  }, [accessToken, page, limit])

  const totalPages = Math.ceil(totalRecords / limit)

  const capitalizeString = str => {
    return str
      .split(" ")
      .map(word => word.slice(0, 1).toLocaleUpperCase() + word.slice(1))
      .join(" ")
  }

  const roleOptions = [
    { name: "Data Analyst", value: "data analyst" },
    { name: "Manager", value: "manager" },
  ]

  const initialUserData = {
    userName: "",
    email: "",
    role: "",
  }

  const [addUserData, setAddUserData] = useState(initialUserData)
  const handleAddUserDataChange = (name, value) => {
    setAddUserData(prevData => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateAddUser = Yup.object().shape({
    userName: Yup.string().required("User name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    role: Yup.string().oneOf(["data analyst", "manager"], "Inavlid User Role"),
  })

  const [errors, setErrors] = useState({})

  const createUser = () => {
    setAddUserLoader(true)
    validateAddUser
      .validate(addUserData, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
        AuthenticationApi.createUser(addUserData, config)
          .then(response => {
            if (response.data.status) {
              getAllAnalystDetails();
              toggle();
              toast.current.show({severity:'success', summary: 'Success', detail: 'User Added successfully', life: 3000});
              setAddUserLoader(false)
            }
          })
          .catch(error => {
            toast.current.show({severity:'error', summary: 'Error', detail: error.response?.data?.message || "Failed to create user. Please try again!", life: 3000});
            setAddUserLoader(false)
          })
      })
      .catch(err => {
        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
        toast.current.show({severity:'error', summary: 'Error', detail: "Please fill all required fields correctly!", life: 3000});
        setAddUserLoader(false)
       
      });
  };

  const handleAddUserClick = () => {
    toggle()
  }

  return (
    <>
      <Row>
        <Col xs="12">
          <div className="user-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Users" />

            <Button
              type="button"
              color="secondary"
              className="waves-effect"
              onClick={handleAddUserClick}
            >
              Add User
            </Button>
          </div>

          <div className="user-data-table table-responsive mt-4 mb-3 ">
            {loading ? (
              <DataTableLoader cols={5} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {usersData?.map((user, index) => (
                    <tr key={user._id} className="user-table-row">
                      <th scope="row">{(page - 1) * limit + index + 1}</th>
                      <td>{user.userName}</td>
                      <td>{user.email}</td>
                      <td>{capitalizeString(user.role)}</td>
                      <td>
                        <span
                          className={`status ${user.isActive ? "active" : "inactive"}`}
                        >
                          {user.isActive ? "Active" : "Inactive"}
                        </span>{" "}
                      </td>

                      {/* {university.verifiedStatus === "pending" ||
                    (["approve", "reject"].includes(
                      university.verifiedStatus,
                    ) &&
                      userData?.role === "manager") ? (
                      <td>
                        <span
                          className="edit-university"
                          onClick={() => {
                            navigate(
                              `/edit-university/${university?.universityCode}`,
                              { state: university },
                            )
                          }}
                        >
                          <i className="ion ion-md-create" />
                        </span>
                      </td>
                    ) : (
                      <td>
                        <span className="edit-university">
                          <i className="fas fa-ban" />
                        </span>
                      </td>
                    )}

                    <td>
                      <span
                        onClick={() => {
                          navigate(
                            `/view-university/${university?.universityCode}`,
                          )
                        }}
                        className="view-university"
                      >
                        <i className="ion ion-md-eye" />
                      </span>
                    </td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
          <div className="pagination-container d-flex align-items-center justify-content-end">
            <Pagination>
              <PaginationItem disabled={page <= 1}>
                <PaginationLink previous onClick={() => setPage(page - 1)} />
              </PaginationItem>
              {[...Array(totalPages)].map((_, index) => (
                <PaginationItem key={index} active={index + 1 === page}>
                  <PaginationLink onClick={() => setPage(index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}

              <PaginationItem disabled={page >= totalPages}>
                <PaginationLink next onClick={() => setPage(page + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        </Col>
      </Row>

      <div className="add-user-dialog">
        <Modal isOpen={modal} toggle={toggle} centered>
          <ModalHeader toggle={toggle}>Invite User</ModalHeader>
          <ModalBody>
            <div className="invite-user-form">
              <div className="form-group">
                <label htmlFor="userName"> Name</label>
                <InputText
                  value={addUserData.userName}
                  onChange={e => {
                    handleAddUserDataChange("userName", e.target.value)
                  }}
                  placeholder="Enter Name"
                />
                {errors.userName && (
                  <small className="error">{errors.userName}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <InputText
                  value={addUserData.email}
                  onChange={e => {
                    handleAddUserDataChange("email", e.target.value)
                  }}
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <small className="error">{errors.email}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="userName">Role</label>
                <Dropdown
                  value={addUserData.role}
                  onChange={e => {
                    handleAddUserDataChange("role", e.target.value)
                  }}
                  optionLabel="name"
                  options={roleOptions}
                  placeholder="Choose Role"
                />
                {errors.role && <small className="error">{errors.role}</small>}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={toggle}>
              Cancel
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                createUser()
              }}
            >
              {addUserLoader ? <Spinner size="sm" /> : " Add "}
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Toast ref={toast} />
      </div>
    </>
  )
}

export default UserList
